import { getMeOptions } from '@/queries/User'
import { saveCurrentUser } from '@/utils/auth.util'
import queryClient from '@/utils/queryClient'

export async function refreshCurrentUser(): Promise<void> {
  try {
    const result = await queryClient.fetchQuery({
      ...getMeOptions(),
      staleTime: 0,
    })
    saveCurrentUser(result)
  } catch {
    // network failure keeps the cached permissions
  }
}
